import React from 'react';
import { Header } from 'semantic-ui-react';
var defaultProps = {
  className: ''
};
export default function Title(_ref) {
  var title = _ref.title,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(Header, {
    className: className,
    size: "large"
  }, title);
}
Title.defaultProps = defaultProps;